import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMortorGlyphSecondary from './svgs/MortorGlyphSecondary.js';
import SvgMortorGlyph from './svgs/MortorGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var mortorGlyph = (props => useIcon(SvgMortorGlyph, SvgMortorGlyphSecondary, props));

export { mortorGlyph as default };
